var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend2Bold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3533 3.94666L10.3133 7.94668C2.22001 10.6534 2.22001 15.0667 10.3133 17.76L13.8867 18.9467L15.0733 22.5201C17.7667 30.6134 22.1933 30.6134 24.8867 22.5201L28.9 10.4934C30.6867 5.09334 27.7533 2.14666 22.3533 3.94666ZM22.78 11.12L17.7133 16.2134C17.5133 16.4134 17.26 16.5067 17.0067 16.5067C16.7533 16.5067 16.5 16.4134 16.3 16.2134C15.9133 15.8267 15.9133 15.1867 16.3 14.8L21.3667 9.70669C21.7533 9.32002 22.3933 9.32002 22.78 9.70669C23.1667 10.0934 23.1667 10.7334 22.78 11.12Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3533 3.94666L10.3133 7.94668C2.22001 10.6534 2.22001 15.0667 10.3133 17.76L13.8867 18.9467L15.0733 22.5201C17.7667 30.6134 22.1933 30.6134 24.8867 22.5201L28.9 10.4934C30.6867 5.09334 27.7533 2.14666 22.3533 3.94666ZM22.78 11.12L17.7133 16.2134C17.5133 16.4134 17.26 16.5067 17.0067 16.5067C16.7533 16.5067 16.5 16.4134 16.3 16.2134C15.9133 15.8267 15.9133 15.1867 16.3 14.8L21.3667 9.70669C21.7533 9.32002 22.3933 9.32002 22.78 9.70669C23.1667 10.0934 23.1667 10.7334 22.78 11.12Z",
    fill: "url(#paint0_linear_1625_2701)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1625_2701",
    x1: 4.24335,
    y1: 3.41791,
    x2: 29.4155,
    y2: 28.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2Bold);
export default __webpack_public_path__ + "static/media/send-2-bold.5ea8413d702612eb25ee76ba888a81ee.svg";
export { ForwardRef as ReactComponent };